// Mock data for Studio 149 Barbershop

export const navigationLinks = [
  { id: 'pocetna', label: 'Početna', href: '#pocetna' },
  { id: 'o-nama', label: 'O nama', href: '#o-nama' },
  { id: 'usluge', label: 'Usluge', href: '#usluge' },
  { id: 'galerija', label: 'Galerija', href: '#galerija' },
  { id: 'tim', label: 'Tim', href: '#tim' },
  { id: 'kontakt', label: 'Kontakt', href: '#kontakt' }
];

export const services = [
  { id: 1, name: 'Muško šišanje', description: 'Klasično i moderno muško šišanje prilagođeno vašem stilu', price: 'Po upitu', icon: 'scissors' },
  { id: 2, name: 'Pranje kose', description: 'Profesionalno pranje kose uz kvalitetne preparate', price: 'Po upitu', icon: 'scissors' },
  { id: 3, name: 'Sređivanje brade', description: 'Precizno oblikovanje i trimovanje brade', price: 'Po upitu', icon: 'scissors' },
  { id: 4, name: 'Šišanje duge kose', description: 'Stručno šišanje i stilizovanje duge kose', price: 'Po upitu', icon: 'scissors' },
  { id: 5, name: 'Fazoniranje', description: 'Završna obrada i fazoniranje frizure', price: 'Po upitu', icon: 'scissors' },
  { id: 6, name: 'Fade, moderna šišanja', description: 'Trendi fade i savremene muške frizure', price: 'Po upitu', icon: 'scissors' }
];

export const teamMembers = [
  { id: 1, name: 'Ana', position: 'Glavni frizer', image: '/ana.jpg', placeholder: false },
  { id: 2, name: 'Bilja', position: 'Glavni frizer', image: '/bilja.jpg', placeholder: false },
  { id: 3, name: 'Djurdja', position: 'Glavni frizer', image: '/djurdja.jpg', placeholder: false },
  { id: 4, name: 'Hana', position: 'Glavni frizer', image: '/hana.jpg', placeholder: false }
];

export const galleryImages = [
  { id: 1, url: 'https://customer-assets.emergentagent.com/job_08ab0d53-6a5d-43ad-8cd9-231b6b4a501a/artifacts/ofcxnf48_1.jpg', alt: 'Galerija slika 1' },
  { id: 2, url: 'https://customer-assets.emergentagent.com/job_08ab0d53-6a5d-43ad-8cd9-231b6b4a501a/artifacts/gxfln7n8_2.jpg', alt: 'Galerija slika 2' },
  { id: 3, url: 'https://customer-assets.emergentagent.com/job_08ab0d53-6a5d-43ad-8cd9-231b6b4a501a/artifacts/ywzwps7n_3.jpg', alt: 'Galerija slika 3' },
  { id: 4, url: 'https://customer-assets.emergentagent.com/job_08ab0d53-6a5d-43ad-8cd9-231b6b4a501a/artifacts/o9t6ucip_4.jpg', alt: 'Galerija slika 4' },
  { id: 5, url: 'https://customer-assets.emergentagent.com/job_08ab0d53-6a5d-43ad-8cd9-231b6b4a501a/artifacts/ukeeoizj_5.jpg', alt: 'Galerija slika 5' }
];

export const slogans = [
  'Profesionalno muško šišanje po pristupačnim cenama',
  'Moderne frizure za savremenog muškarca',
  'Kvalitet i stil u jednom mestu'
];

export const contactInfo = {
  address: 'Cara Dušana 153, Zemun',
  phone: '062/972 96 71',
  workingHours: { weekdays: 'Ponedeljak – Petak od 08h-20h', saturday: 'Subota od 08h-16h' }
};

export const aboutText = `Frizerski salon Studio 149 nudi kompletne frizerske usluge svim savremenim muškarcima koji drže do svog izgleda i stila. Sa željom da vaša kosa bude negovana, lepa i moderna, u prijatnom ambijentu našeg salona, nudimo vam muško šišanje, po najpovoljnijim cenama.

Dobra frizura može učiniti da izgledate i osećate se bolje, a naš tim profesionalnih frizera sačinjen od ljudi koji su profesionalci u svom poslu, svojim savetima će vam pomoći da odaberete odgovarajuću frizuru. Zahvaljujući dugogodišnjem iskustvu, nudimo vam usluge profesionalnog muškog šišanja, uz upotrebu vrhunskih preparata za negu kose.

Studio 149 frizerski salon nudi vam veliki izbor klasičnih i modernih muških frizura, u skladu sa modnim trendovima i zahtevima savremenog muškarca. Zahvaljujući brojnosti našeg tima koji čine vrhunski frizeri, nudimo vam brzu uslugu i uštedu vašeg dragocenog vremena.

Kako bi vaša frizura uvek izgledala moderno, nudimo vam muško šišanje, po pristupačnim cenama i uz upotrebu najkvalitetnijih preparata. Kvalitet naših usluga prepoznat je od strane velikog broja zadovoljnih klijenata, koji nam se uvek rado vraćaju.`;

export const heroImages = [
  'https://images.unsplash.com/photo-1654097801176-cb1795fd0c5e',
  'https://images.unsplash.com/photo-1654097803253-d481b6751f29',
  'https://images.unsplash.com/photo-1654097800183-574ba7368f74',
  'https://images.unsplash.com/photo-1678356163587-6bb3afb89679',
  'https://images.unsplash.com/photo-1596362601603-b74f6ef166e4',
  'https://images.unsplash.com/photo-1605497788044-5a32c7078486'
];

export const logoUrl = 'https://customer-assets.emergentagent.com/job_08ab0d53-6a5d-43ad-8cd9-231b6b4a501a/artifacts/01cbnrao_LOGO%202%20BELE%20BOJE.png';